// extracted by mini-css-extract-plugin
module.exports = {"pop_up_window":"prop_pop_up_window__3F0p4","shade":"prop_shade__32ZmP","content":"prop_content__3ES4r"};